var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loaded)?_c('div',{staticStyle:{"text-align":"left"},domProps:{"innerHTML":_vm._s(_vm.info)}}):_c('div',{staticStyle:{"text-align":"left"},domProps:{"innerHTML":_vm._s(_vm.json2Html(_vm.formData.body))}})}
var staticRenderFns = []

export { render, staticRenderFns }